module.exports = __webpack_public_path__ + "static/img/hypnose-landing.57b5a2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hypnose-landing.png
// module id = 101
// module chunks = 0